module.exports = __webpack_public_path__ + "img/fig15.151f449f.jpg";